import { keyArgsForPagination, mergeForPagination } from "./modules/utils";

const StudentTypePolicy = {
  Student: {
    fields: {
      transcript: {
        merge: true,
      },
      alerts: {
        keyArgs: args => {
          if (args) {
            const keys = keyArgsForPagination(args);
            return [keys];
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPagination({
              existing,
              incoming,
              readField,
              filters: args,
            });
          }
          return incoming;
        },
      },
    },
  },
};

export default StudentTypePolicy;
